$(document).ready(()=> {

    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });


    $('[data-toggle]').on('click', function()
    {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $('[data-toggle="showbox"][data-target="'+target_name+'"]');

        if(toggle_name == 'openbox')
        {
            let target_status = target_element.data('status');
            $('[data-toggle="showbox"]:not([data-target="'+target_name+'"])').attr('data-status',false);

            if(target_status == false)
            {
                target_element.attr('data-status',true);
            }
            else
            {
                target_element.attr('data-status',false);
            }
        }
        else if(toggle_name == 'closebox')
        {
            target_element.attr('data-status',false);
        }
    });

    $(document).on('click',function(){
        $('[data-toggle="showbox"]').attr('data-status',false);
    });

    $(document).on('keyup',function(e) {
        if (e.key === "Escape") {
            $('[data-toggle="showbox"]').attr('data-status',false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function(event){
        event.stopPropagation();
    });



    // Tabs
    //=====================================================================

    $(document).on('click','li[data-tab]',function(){
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="'+target+'"][data-tab="'+tab+'"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });


    $(document).on('mouseover','li[data-tab-hover]',function(){
        let $this = $(this),
            tab = $this.data('tab-hover'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="'+target+'"][data-tab="'+tab+'"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });


    // Toaster Alert
    //=====================================================================

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    var scroll = $(window).scrollTop();
    if(scroll > 50)
    {
        $('body').addClass('body--header-fix')
    }
    else
    {
        $('body').removeClass('body--header-fix')
    }

    $(window).scroll(()=> {
        scroll = $(window).scrollTop();
        if(scroll > 50)
        {
            $('body').addClass('body--header-fix')
        }
        else
        {
            $('body').removeClass('body--header-fix')
        }
    });

    // Toast.fire({
    //     icon: 'success',
    //     title: 'توستر',
    //     footer: 'این تست توستر است',
    // });

    $('[data-color]').each(function(i,e){
        $(e).css('color',$(e).data('color'));
    })

    $('.profile__sidebar nav li').has('>ul').addClass('has-child').prepend('<i class="dn-arrow-down"></i>');

    $('.profile__sidebar nav li.has-child >a').on('click',function(){

        let $this = $(this).parent();
        let $child = $(this).siblings('ul');
        if($this.hasClass('active'))
        {
            $child.slideUp(200,function(){
                $this.removeClass('active');
            });
        }
        else
        {
            $child.slideDown(200,function(){
                $this.addClass('active');
            });
        }

    });


    $('.profile__header__toggle').on('click',function(){

        $('.profile__wrapper').toggleClass('profile__wrapper--collapse');

    });




    $(".auth__btns a").on("click", function() {
        var $this = $(this);
        $('.auth__form--form').hide();
        $('.auth__form--code').show();

        var t = new Date($.now());
        t.setSeconds(t.getSeconds() + 5);
        var $timer = $('.auth__form__actions span span');
        $('.auth__form__actions').addClass('auth__form__actions--timer');


        $timer.countdown(t)
            .on('update.countdown', function(event) {
                $timer.html(event.strftime('%-M:%S'));
            })
            .on('finish.countdown', function(event) {
                $('.auth__form__actions').removeClass('auth__form__actions--timer');
            });
    });


    $('.auth__form__actions a').on("click", function() {
        var t = new Date($.now());
        t.setSeconds(t.getSeconds() + 5);
        var $timer = $('.auth__form__actions span span');
        $('.auth__form__actions').addClass('auth__form__actions--timer');
        $timer.countdown(t)
            .on('update.countdown', function(event) {
                $timer.html(event.strftime('%-M:%S'));
            })
            .on('finish.countdown', function(event) {
                $('.auth__form__actions').removeClass('auth__form__actions--timer');
            });
    });

    $('.auth__form__header a').on("click", function() {
        $('.auth__form--form').show();
        $('.auth__form--code').hide();
    });


    $('.auth__form__dashed input').on('keypress',function (){
        var number = $(this).val();
        if(number.length >= 5) {
            $(this).val(number.slice(0, 5));
            return false;
        }
    });



    $(".datepicker").persianDatepicker({
        observer: true,
        format: 'YYYY/MM/DD',
        autoClose: true
    });

    var main_slider = new Swiper('.intro .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: 1,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0
        },
    });

    var customers_slider = new Swiper('.customers-comment .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: 1,
        centeredSlide: 1,
        autoplay: {
            delay: 4000,
            disableOnInteraction: 0
        },
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });


    $(document).on('keyup','.profile__content__wallets__search input',function(){
        var val = $(this).val();
        $(".profile__content__wallets__item").each(function() {
            if (
                ($(this).data('en-title').search(val) == 0) ||
                ($(this).data('fa-title').search(val) == 0) ||
                ($(this).data('min-title').search(val) == 0)
            )
            {
                $(this).removeClass('profile__content__wallets__item--no-result');
            }
            else {
                $(this).addClass('profile__content__wallets__item--no-result');
            }
        });

    });


    var t = new Date($.now());
    t.setSeconds(t.getSeconds() + 300);
    var $timer = $('.profile__content__form__timer span');
    $timer.countdown(t)
        .on('update.countdown', function(event) {
            $timer.find('b[data-m]').html(event.strftime('%-M'));
            $timer.find('b[data-s]').html(event.strftime('%-S'));
            $timer.parent().addClass('pulse');
            setTimeout(()=>{
                $timer.parent().removeClass('pulse');
            },100);
        })
        .on('finish.countdown', function(event) {
            $timer.html('زمان اجرای تراکنش به پایان رسید :(');
        });


    $('[data-copy-text]').on('click',function(){
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val($(this).text()).select();
        document.execCommand("copy");
        $temp.remove();

        Toast.fire({
            icon: 'success',
            title: 'آدرس کیف پول کپی شد!'
        });

    });


    const pickr = new Pickr({
        el: '.color-picker',
        theme: 'classic', // or 'monolith', or 'nano'
        default: '#eee',

        swatches: [
            'rgba(244, 67, 54, 1)',
            'rgba(233, 30, 99, 1)',
            'rgba(156, 39, 176, 1)',
            'rgba(103, 58, 183, 1)',
            'rgba(63, 81, 181, 1)',
            'rgba(33, 150, 243, 1)',
            'rgba(3, 169, 244, 1)',
            'rgba(0, 188, 212, 1)',
            'rgba(0, 150, 136, 1)',
            'rgba(76, 175, 80, 1)',
            'rgba(139, 195, 74, 1)',
            'rgba(205, 220, 57, 1)',
            'rgba(255, 235, 59, 1)',
            'rgba(255, 193, 7, 1)'
        ],

        components: {

            // Main components
            preview: true,
            opacity: true,
            hue: true,

            // Input / output Options
            interaction: {
                hex: true,
                rgba: false,
                hsla: false,
                hsva: false,
                cmyk: false,
                input: true,
                clear: false,
                save: true
            }
        },
        i18n: {
            'btn:save': 'انتخاب',
        }
    });

    pickr.on('changestop', instance =>
    {
        var color = pickr.getColor().toHEXA().toString();
        $('#wallet-color').val(color)
        pickr.applyColor(true)
    });

    pickr.on('swatchselect', instance =>
    {
        var color = pickr.getColor().toHEXA().toString();
        $('#wallet-color').val(color)
        pickr.applyColor(true)
    });

    pickr.on('save', instance =>
    {
        pickr.hide()
    });



    var circle_chart = new Chart($('#chart__circle')[0], {
        type: 'doughnut',
        data: {
            datasets: [{
                data: [10, 20, 30],
                backgroundColor: [
                    '#f2a900',
                    '#3d9f80',
                    '#006097'
                ],
            }],
            labels: [
                'Bitcoin',
                'Tether',
                'Ripple'
            ]
        },
        options:
            {
                maintainAspectRatio: false,
            }
    });


    var line_chart = new Chart($('#chart__line')[0], {
        type: 'line',
        data: {
            datasets: [{
                data: [5,10,3,8,5,10,8,7,2,9],
                backgroundColor: '#f2a900',
                borderColor: '#ccc',
                fill: false,
                label: 'Bitcoin'
            }],
            labels: [
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10'
            ]
        },
        options:
            {
                elements:
                    {
                        line:
                            {
                                tension: 0.000001,
                            }
                    },
                maintainAspectRatio: false,
            }
    });


    $("#send_sms").on('click',function (){
        var $this = $(this);
        var text = $(this).html();
        $this.css({'background-color':'#555','color':'#fff'});
        var t = new Date($.now());
        t.setSeconds(t.getSeconds() + 120);
        $this.countdown(t)
            .on('update.countdown', function(event) {
                $this.html(event.strftime('%-M:%S'));
            })
            .on('finish.countdown', function(event) {
                $this.removeAttr('style').html(text)
            });
    })

    //=============================//
    // r.dadkhah.tehrani@gmail.com //
    //=============================//

});
